'use strict';

const cssConstants=require("../utils/cssConstants");

module.exports = {
    nameValidation: function () {
        const inputSelectors = [
            '#registration-form-lname',
            '#login-form-lname',
            '#registration-form-fname',
            '#login-form-fname',
            '#address-form-lname',
            '#address-form-fname',
            '#billing-address-fname',
            '#billing-address-lname'
        ];
        $(inputSelectors.join(', ')).on('blur keyup', function (e) {
            var nameVal = $(e.target).val();
            var $formGroup = $(e.target).parents('.form-group');
            var $fieldError = $formGroup.find('.invalid-feedback');
            var $nameMatch = $formGroup.find('.js-name-match');
            var $nameHelper = $formGroup.find('.js-name-helper');
            var $nameHelperList = $formGroup.find('.js-name-helper-list');
            var nameRegExp = /^[^0-9@#$%^&*()_+=\{\}\[\]|\\:;\"<>,\.?/!]*$/; // eslint-disable-line no-useless-escape

            if (e.type === 'keyup' && !$(e.target).hasClass(cssConstants.INVALID) && !$(e.target).hasClass(cssConstants.VALID)) {
                return;
            }

            if (!nameVal.match(nameRegExp)) {
                $nameMatch.addClass(cssConstants.SHOW_BLOCK);
            } else {
                $nameMatch.removeClass(cssConstants.SHOW_BLOCK);
            }

            if ($nameHelperList.children('.' + cssConstants.SHOW_BLOCK).length) {
                $nameHelper.removeClass(cssConstants.HIDDEN);
                $(e.target).addClass(cssConstants.INVALID).removeClass(cssConstants.VALID);
                $formGroup.addClass(cssConstants.INVALID);
                $fieldError.addClass(cssConstants.HIDDEN);
            } else {
                $nameHelper.addClass(cssConstants.HIDDEN);
                $(e.target).removeClass(cssConstants.INVALID).addClass(cssConstants.VALID);
                $formGroup.removeClass(cssConstants.INVALID);
            }
        });
    },
};


